/* eslint-disable react-refresh/only-export-components */
import type { Dispatch, SetStateAction } from 'react';
import { createRoot } from 'react-dom/client';

let setLoading_: Dispatch<SetStateAction<boolean>>;
let setPercent_: Dispatch<SetStateAction<'auto' | undefined>>;

function Loading() {
  const [loading, setLoading] = useState(true);
  const [percent, setPercent] = useState<'auto' | undefined>(undefined);
  setLoading_ = setLoading;
  setPercent_ = setPercent;
  return <Spin spinning={loading} percent={percent} fullscreen />;
}

createRoot(document.getElementById('loading')!).render(<Loading />);

export function setGlobalLoading(loading: boolean | 'percent') {
  setLoading_(Boolean(loading));
  setPercent_(loading === 'percent' ? 'auto' : undefined);
}
